import type { CSSProperties, ReactNode } from 'react';

import classNames from 'classnames';

import { figcaption } from '../figCaption/FigCaption.css';
import { figcaptionWrapper, linkedFigcaptionWrapper } from './Figcaption.css';

export const FigcaptionWrapper = ({
  children,
  linked,
  className,
  style,
}: {
  children: ReactNode;
  linked?: boolean;
  className?: string;
  style?: CSSProperties;
}) => {
  return (
    <div
      className={classNames(figcaptionWrapper, figcaption, linked && linkedFigcaptionWrapper, className)}
      style={style}
    >
      {children}
    </div>
  );
};
